import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import Modal from './CustomModal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react';
import toast from 'react-hot-toast';
import AuthHandler from '../Classes/AuthHandler';
import { UpdatePoStatusforPOacceptanceRequest } from '../store/actions/poDetailsActions';
import { uploadFileGeneric, GenericUploadVersionFile } from './../store/actions/fileActions';
import { postCommentsForPOs } from '../store/actions/expediting.Actions'

class RejectPOAcceptance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            poId: this.props.poID,
            reviseForm: {
                file: [],
                comment: ""
            },
            uploadID: this.props.uploadID

        }

        this.modal = this.modal.bind(this);

    }


    modal = async (type) => {
        this.props.toggleReviseModal(type)

    }
    handleFileInput = (event) => {
        let fileList = [];
        fileList.push(event.target.files[0])
        let reviseForm = this.state.reviseForm
        reviseForm.file = fileList
        this.setState({ reviseForm });
        console.log(this.state.reviseForm)
    }

    formChange = (e) => {
        console.log("Event", e.target.value);
        let reviseForm = this.state.reviseForm
        reviseForm.comment = e.target.value;
        this.setState({ reviseForm });
    }
    formSaveAction = async (flag) => {
        if (flag == 2) {
            let comments = "test"
            // console.log(this.state.uploadID,"this.state.uploadID")
            if (this.state.reviseForm.file.length < 1) {
                swal("Choose A File First", { button: true, icon: "warning" })
                return false
            }
            this.modal(false);
            this.props.setLoader(true)
            // var result = await this.props.uploadFileGeneric(this.state.reviseForm.file)
            var result = await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.props.uploadID, comments, AuthHandler.getUserID());
            console.log(result.results, "resulttttttt")
            var uploadfile = result.results
            await this.props.UpdatePoStatusforPOacceptanceRequest(this.props.poID, 5).then(() => {
                toast.success('Ammended PO Uploade & PO Acceptance Requested...', {
                    duration: 7000
                });
            });
            await this.props.postCommentsForPOs({
                Comments: this.state.reviseForm.comment,
                UserId: AuthHandler.getUserID(),
                POId: this.props.poID,
                DocumentId: uploadfile[0].DocumentId,
            })
            await this.props.datasync()
            return false
        }
        if (flag == 1) {
            let comments = "test"
            this.props.setLoader(true)
            // console.log(this.state.uploadID,"this.state.uploadID")
            await this.modal(false);
            if (this.state.reviseForm.file.length < 1) {
                this.props.setLoader(true)
                await this.props.UpdatePoStatusforPOacceptanceRequest(this.state.poId, 2, 0, 0)
                await this.props.postCommentsForPOs({
                    Comments: this.state.reviseForm.comment,
                    UserId: AuthHandler.getUserID(),
                    POId: this.state.poId,
                    DocumentId: this.props.uploadID,
                })
                await toast.success('PO Acceptance Revised...', {
                    duration: 5000
                });
                await this.props.datasync()
                return false
            }
            // swal("Document is uploading...",{button:false,icon:"info"})

            // var result = await this.props.uploadFileGeneric(this.state.reviseForm.file)
            var result = await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.props.uploadID, comments, AuthHandler.getUserID());
            console.log(result.results, "resulttttttt")
            var uploadfile = result.results
            await this.props.UpdatePoStatusforPOacceptanceRequest(this.state.poId, 2, uploadfile[0].DocumentId, uploadfile[0].VersionId).then(async () => {
                await this.props.postCommentsForPOs({
                    Comments: this.state.reviseForm.comment,
                    UserId: AuthHandler.getUserID(),
                    POId: this.state.poId,
                    DocumentId: uploadfile[0].DocumentId,
                })
                toast.success('PO Acceptance Revised...', {
                    duration: 5000
                });
            })

        } else {
            let comments = "test"
            // console.log(this.state.uploadID,"this.state.uploadID")
            if (this.state.reviseForm.file.length < 1) {

                swal("Please upload some valid document", { icon: "error" })

                return false;
            }
            await this.modal(false);
            this.props.setLoader(true)
            // swal("Document is uploading...",{button:false,icon:"info"})

            // var result = await this.props.uploadFileGeneric(this.state.reviseForm.file)
            console.log(this.props.uploadID, "JH=========>")
            var result = ""
            if (this.props.uploadID === null) {
                result = await this.props.uploadFileGeneric(this.state.reviseForm.file, AuthHandler.getUserID());
            } else {
                result = await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.props.uploadID, comments, AuthHandler.getUserID());
            }
            console.log(result.results, "resulttttttt")
            var uploadfile = result.results
            await this.props.UpdatePoStatusforPOacceptanceRequest(this.state.poId, 7, uploadfile[0].DocumentId, uploadfile[0].VersionId).then(async () => {
                await this.props.postCommentsForPOs({
                    Comments: this.state.reviseForm.comment,
                    UserId: AuthHandler.getUserID(),
                    POId: this.state.poId,
                    DocumentId: uploadfile[0].DocumentId,
                })

                toast.success('PO Acceptance Approved...', {
                    duration: 5000
                });
            })
        }
        this.modal(false);
        this.props.datasync()
    }

    render() {
        console.log(this.props.flagR, "flag")

        return (
            <div>

                <div>
                    <Modal isOpen={this.props.action} >
                        <div className={"modal-bg" + (this.props.action === 'false' ? 'open' : '')}>
                            <div className={"modal-bg" + (this.state.OpenVersionModal == true ? 'open' : '')}>
                                <div className="modalheads">
                                    <ModalHeader HeaderStyle="modal-header">
                                        {this.props.flagR == 1 ?
                                            <div className="modal-text"><h4 >Upload PO Acceptance & Approve</h4></div>
                                            : this.props.flagR == 2 ?
                                                <div className="modal-text"><h4 >PO Details Document</h4></div>
                                                : <div className="modal-text"><h4 >Revise PO Acceptance</h4></div>
                                        }
                                        <button type="button" className="close" aria-label="Close" onClick={() => this.modal(false)} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </ModalHeader>
                                </div>
                                <ModalBody Style="modal-body modalbodyssmall">

                                    <div className="row ">
                                        <div className="col-8"></div>
                                        <div className="col-4 pb-2">
                                            {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                        </div>
                                    </div>
                                    <div className="row ">
                                        <div className="col-sm-10">
                                            Select File:
                                        </div>
                                        <br />
                                        <div className="col-sm-8 mt-2">
                                            <input type="file" className="form-control-file" name="" onChange={(e) => { this.handleFileInput(e) }} id="exampleFormControlFile2" />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-sm-6">
                                            Comment :
                                        </div>
                                        <div className="col-sm-6">
                                            <textarea className="form-control" onChange={(e) => this.formChange(e)} value={this.state.reviseForm.comment}></textarea>
                                        </div>
                                    </div>
                                </ModalBody>
                            </div>
                            <div className="">
                                <ModalFooter FooterStyle="modal-footer">
                                    <div>
                                        {this.props.flagR == 1 ?
                                            <button className="btn2 btn-sms1 mt-2 ml-2 float-right rounded-pill" onClick={() => this.formSaveAction(0)} type="submit">Upload & Approve</button>
                                            : this.props.flagR == 2 ?
                                                <button className="btn2 btn-sms1 mt-2 ml-2 float-right rounded-pill" onClick={() => this.formSaveAction(2)} type="submit">Upload & Request</button>
                                                : <button className="btn2 btn-sms1 mt-2 ml-2 float-right rounded-pill" onClick={() => this.formSaveAction(1)} type="submit">Sent For Revision</button>
                                        }
                                        <button className="btn2 btn-sms1 mt-2 ml-2 rounded-pill" onClick={() => this.modal(false)} type="submit">Close</button>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </Modal>
                </div>

            </div>


        )

    }
}


const mapStateToProps = (state) => ({ poDetails: state.poDetails, file: state.file, })
export default connect(mapStateToProps, { UpdatePoStatusforPOacceptanceRequest, uploadFileGeneric, GenericUploadVersionFile, postCommentsForPOs })(RejectPOAcceptance)